import script from "./WindMeter.vue?vue&type=script&setup=true&lang=ts"
export * from "./WindMeter.vue?vue&type=script&setup=true&lang=ts"

import "./WindMeter.vue?vue&type=style&index=0&id=1e57ba0e&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e57ba0e"]])

export default __exports__